class ApiConfig {

	static baseUrl = 'https://www.gkq211.com/';
	static path = '';
	static uploadUrl = '';
	static uploadPath = '';
	static cdnUrl = "https://www.gkq211.com";
	static staticImgUrl = ''; 

}

export default ApiConfig;